import React from "react";
import {connect} from "react-redux";
import {Heading} from "./Heading";
import {Label} from "./tooltipLabel";
import {Input} from "./inputComponent";
import languages from "../collections/languages";
import {getAge} from "../scripts/validation"
import {setSame} from "../redux/actions";

class data extends React.Component {
    constructor(props) {
        super ( props );
        this.state = {
            isSame : true
        };
        this.handleChangeSame = this.handleChangeSame.bind ( this );

    }

    handleChangeSame() {
        getAge ( this.props.jmbg )>=14 ?
            this.setState (
                { isSame : true, age: getAge ( this.props.jmbg ) }, ()=>{
                    this.props.setSame ( { isSame : this.state.isSame } )
                } ) :
            this.setState (
                { isSame : false, age : getAge ( this.props.jmbg ) }, ()=>{
                    this.props.setSame ( { isSame : this.state.isSame } )
                } );

    }

    render() {
        return (<div>
                <Heading
                    text={"headingData"}
                />
                <Label
                    text={"insured"}
                    tooltip={"insuredTooltip"}/>
                <div className={"input-group flex-between input-text"}>
                    <Input
                        className={"uppercase "}
                        change={this.props.handleChangeInsuredName}
                        type={"text"}
                        placeholder={!languages[this.props.lang] ? " " : languages[this.props.lang].fName}/>
                    <Input
                        className={"uppercase "}
                        change={this.props.handleChangeInsuredLastname}
                        type={"text"}
                        placeholder={!languages[this.props.lang] ? " " : languages[this.props.lang].lName}/>
                    <Input
                        change={this.props.handleChangeInsuredJmbg}
                        type={"number"}
                        placeholder={!languages[this.props.lang] ? " " : languages[this.props.lang].JMBG}
                        blur={(e)=>{this.props.handleJmbgInsuredValidity(e); if (!!this.props.jmbg) {this.handleChangeSame()}}}
                    />
                </div>
                {!this.state.isSame && <div>
                    <Label
                        text={"contractor"}
                        tooltip={"contractorTooltip"}/>
                    <div className={"input-group flex-between input-text"}>
                        <Input
                            autoFocus = {true}
                            ref={(InputF) => { this.nameInput = InputF; }}
                            className={"uppercase "}
                            change={this.props.handleChangeContractorName}
                            type={"text"}
                            placeholder={!languages[this.props.lang] ? " " : languages[this.props.lang].fName}/>
                        <Input
                            className={"uppercase "}
                            change={this.props.handleChangeContractorLastname}
                            type={"text"}
                            placeholder={!languages[this.props.lang] ? " " : languages[this.props.lang].lName}/>
                        <Input
                            change={this.props.handleChangeContractorJmbg}
                            type={"number"}
                            placeholder={!languages[this.props.lang] ? " " : languages[this.props.lang].JMBG}
                            blur={(e) => {
                                if (!!this.props.jmbg) {
                                    this.props.handleJmbgContractorValidity ( e )
                                }
                            }}
                        />
                    </div>
                </div>}
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return ({
        lang : state ? state.lang : '' ,
    });
};

const mapDispatchToProps = (dispatch) => {
    return ({
        setSame : (params) => {
            dispatch ( setSame ( params ) );
        }
    })
};

export const PersonalData = connect ( mapStateToProps , mapDispatchToProps ) ( data );